import ServiceIdentitySP from './ServiceIdentitySP';

export default ServiceIdentitySP;
